import round from './round';

export default function format_bitrate (bitrate, format = 'kbps') {
  const kilobits_per_second = bitrate / 1000;
  const kilobytes_per_second = kilobits_per_second / 8;
  const megabits_per_second = kilobits_per_second / 1000;
  const megabytes_per_second = megabits_per_second / 8;

  if (format === 'kbps') {
    return round(kilobits_per_second, 1);
  }

  if (format === 'KBps') {
    return round(kilobytes_per_second, 1);
  }

  if (format === 'kbph') {
    return round(kilobits_per_second * 60 * 60, 1);
  }

  if (format === 'KBph') {
    return round(kilobytes_per_second * 60 * 60, 1);
  }

  if (format === 'mbps') {
    return round(megabits_per_second, 1);
  }

  if (format === 'MBps') {
    return round(megabytes_per_second, 1);
  }

  if (format === 'mbph') {
    return round(megabits_per_second * 60 * 60, 1);
  }

  if (format === 'MBph') {
    return round(megabytes_per_second * 60 * 60, 1);
  }
}
